/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  ContextMenu,
  Column,
  Row,
  Text,
  ListItem,
  Icon,
  IconNames,
  TEXT_VARIANTS,
  ExternalLink,
} from "../..";
import { COLORS } from "../../../shared/theme";

export const MemberCard: React.FC = () => (
  <Card
    css={css`
      transition: all 120ms ease;
      cursor: pointer;
      padding: 10px;
      border: none;
      box-shadow: 0 0.1rem 0.5rem rgb(0 0 0 / 10%);

      &:hover {
        box-shadow: 0 0.5rem 1.5rem rgb(0 0 0 / 10%);
      }

      &:hover .feed-card__footer__connections {
        color: ${COLORS.GREEN};
      }
    `}
  >
    <Link
      to="/id"
      css={css`
        text-decoration: none;
        color: inherit;
      `}
    >
      <Column gap={5}>
        <Column gap={10}>
          <img
            alt="profile"
            src="https://randomuser.me/api/portraits/women/12.jpg"
            css={css`
              width: 75px;
              height: 75px;
            `}
          />
          <Column gap={5} mainAxisAlignment="start">
            <Text variant={TEXT_VARIANTS.T30}>{"Sari Azout"}</Text>
            <Text
              variant={TEXT_VARIANTS.T20}
              css={css`
                color: #949ca6;
              `}
            >
              {"@sari"}
            </Text>
            <Text variant={TEXT_VARIANTS.T20}>
              {"curating the internet @sublime"}
            </Text>
            <ExternalLink>{"sariazout.substack.com"}</ExternalLink>
          </Column>
        </Column>
        <Row crossAxisAlignment="center" mainAxisAlignment="space-between">
          <Text
            className="feed-card__footer__connections"
            role="button"
            variant={TEXT_VARIANTS.T30SOFT}
            css={css`
              transition: all 120ms ease;
              cursor: pointer;
              color: ${COLORS.NUMBER};
            `}
          >
            {8}
          </Text>
          <Row gap={5}>
            <ContextMenu
              renderElement={(toggleOpen) => (
                <Button
                  leadingElement={() => <Icon name={IconNames.More} />}
                  onClick={toggleOpen}
                />
              )}
              renderMenu={() => (
                <Column
                  gap={5}
                  css={css`
                    width: 250px;
                    padding: 5px;
                  `}
                >
                  <ListItem
                    icon={<Icon name={IconNames.Edit} />}
                    label="Edit"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Share} />}
                    label="Copy link"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Pinned} />}
                    label="Pin"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Unpin} />}
                    label="Unnpin"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Favorites} />}
                    label="Favorite"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Unfavorite} />}
                    label="Unfavorite"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Disconnect} />}
                    label="Remove connection"
                  />
                  <ListItem
                    icon={<Icon name={IconNames.Delete} />}
                    label="Delete"
                  />
                </Column>
              )}
            />
            <Button leadingElement={() => <Icon name={IconNames.Share} />} />
            <Button label="Follow" />
          </Row>
        </Row>
      </Column>
    </Link>
  </Card>
);
